<ng-template #filterButtonRef>
  <span class="position-relative" (click)="accessPointActivityFilter()">
    <img
      class="filter-menu-icon pointer-cursor m-1"
      src="assets/svg/ico-menu-circle.svg"
      alt="ico-menu-circle"
    />
    <span class="mf-badge" *ngIf="filterCount !== 0">
      <span class="circle-content">
        {{ filterCount || "" }}
      </span>
    </span>
  </span>
</ng-template>
<div class="activity-accesspoint">
  <div class="header mt-1 w-100">
    <div class="d-flex justify-content-between align-items-center w-100">
      <img src="" />
      <div class="text-center access-point-name">
        <h4 class="mb-2">
          <span> {{ title }} </span>
        </h4>
        <h1 class="modal-title mtm-10 mb-0">
          {{ 'ACTIVITIES' | translate }}
        </h1>
      </div>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="listing activity-list activity-list-height my-4">
    <div class="container-viewall-activity">
      <app-activity
        [activities]="activities | async"
        (scrollDown)="scrollDownEmitter($event)"
        [canLoad]="canLoad"
      >
        <span headerElement class="filter-activity">
          <ng-container *ngIf="(activities | async)?.events?.length >= 0">
            <ng-template [ngTemplateOutlet]="filterButtonRef"></ng-template>
          </ng-container>
        </span>
      </app-activity>
    </div>
  </div>
</div>
